import React from 'react'
import { Field, reduxForm } from 'redux-form'
import { Redirect } from 'react-router-dom'

const Login = ({ handleSubmit, submitting, location, isAuthenticated }) => {
  const { from } = location.state || { from: { pathname: '/' } }
  if (isAuthenticated) {
    return <Redirect to={from}/>
  }
  return (
    <div className="row align-items-center justify-content-center">
      <div className="card wd-350 shadow-base bg-light bd-0" style={{ marginTop: '5rem', marginBottom: '5rem' }}>
        <div className="card-body">
          <form className="form-layout form-layout-1 bd-0" onSubmit={handleSubmit}>
            <img className="logo-login" src="logo.png"/>
            <h5 className="tx-xs-24 tx-normal tx-gray-900 mg-b-30 mg-t-30">Sansiri Defect Report</h5>
            <div className="form-group mg-b-10">
              <div>
                <Field id="username" name="username" component="input" type="text" placeholder="Username"
                       className="form-control"/>
              </div>
            </div>
            <div className="form-group mg-b-10">
              <div>
                <Field id="password" name="password" component="input" type="password" placeholder="Password"
                       className="form-control"/>
              </div>
            </div>
            <div>
              <button type="submit" className="btn btn-primary btn-block" disabled={submitting}>Login</button>
            </div>
          </form>
        </div>
      </div>
    </div>
  )
}

export default reduxForm({
  form: 'login'
})(Login)


// WEBPACK FOOTER //
// ./src/components/Login.js